import React from "react";
import Select from "react-select";
import { ValueType } from "react-select/src/types";
import DropdownArrow from "assets/Icon_Dropdown_Arrow.png";
import classNames from "classnames";

export type SelectOption = { value: any; label: string };

type DropdownProps = {
  label?: string;
  name: string;
  options: { value: string; label: string }[];
  value: ValueType<SelectOption, boolean>;
  onChange(selectedOption: ValueType<SelectOption,boolean>): void;
  type: "Filter" | "Category" | "FullWidth";
  placeholder?: string;
  highlighted?: boolean;
};

type Props = DropdownProps;

const DropdownIndicator = () => {
  return (
    <img
      alt=""
      src={DropdownArrow}
      style={{ height: "6px", paddingRight: "10px" }}
    />
  );
};

const Dropdown: React.FC<Props> = ({
  label,
  name,
  options,
  value,
  onChange,
  type,
  placeholder,
  highlighted,
}) => {
  const cn = classNames("CustomSelect", {
    Filter: type === "Filter",
    Category: type === "Category",
    FullWidth: type !== "Filter" && type !== "Category",
    Highlighted: highlighted,
  });

  return (
    <label className="FilterLabel">
      {label}
      <Select
        name={name}
        value={value}
        options={options}
        className={cn}
        classNamePrefix="CustomSelect"
        onChange={onChange}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
        placeholder={placeholder}
        components={{ DropdownIndicator }}
      />
    </label>
  );
};

export { Dropdown };
